import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
const ImageLightBox = ({ children, src, alt, isImageOpen, Wrapper = 'div', zIndex = 100 }) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleIsOpen = () => {
		setIsOpen(!isOpen);
	};
	useEffect(() => {
		setIsOpen(!isOpen);
	}, [])

	return (
		<Wrapper onClick={toggleIsOpen}>
			{isImageOpen ?
				<div onClick={toggleIsOpen} style={{
					position: 'absolute',
					height: '100vh',
					width: '100vw',
					backgroundColor: 'rgba(0,0,0,1)',
					cursor: 'pointer',
					zIndex,
					top: '0%',
					left: '0%',
					

				}}>
					<img src={src}
						alt={alt}
						style={{
							height: '94vh',
							width: 'auto',
							marginLeft: 'auto',
							marginRight: 'auto',
							display: 'block',
							marginTop: '40px'
						}}
					/>
				</div>
				: null}
				{children}
		</Wrapper>
	);
};

export default ImageLightBox;
ImageLightBox.propTypes = {
    children: PropTypes.node,
    src: PropTypes.string,
	alt: PropTypes.string,
	Wrapper:PropTypes.string,
	zIndex: PropTypes.number,
	isImageOpen:PropTypes.bool
}
